import { render, staticRenderFns } from "./VehiculeForm.vue?vue&type=template&id=65dfe134&scoped=true&"
import script from "./VehiculeForm.vue?vue&type=script&lang=js&"
export * from "./VehiculeForm.vue?vue&type=script&lang=js&"
import style0 from "./VehiculeForm.vue?vue&type=style&index=0&id=65dfe134&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dfe134",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65dfe134')) {
      api.createRecord('65dfe134', component.options)
    } else {
      api.reload('65dfe134', component.options)
    }
    module.hot.accept("./VehiculeForm.vue?vue&type=template&id=65dfe134&scoped=true&", function () {
      api.rerender('65dfe134', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/transports/components/VehiculeForm.vue"
export default component.exports